import React, { memo } from 'react';

import './styles.scss';

export enum ButtonColors {
  blue = 'blue',
  green = 'green',
}

interface IButton {
  title: string;
  color?: ButtonColors;
  className?: string;
  description?: string;
  onClick?: () => void;
}

const Button: React.FC<IButton> = ({ title, color, className, description, onClick }) => {
  return (
    <div className="btn-container">
      <button className={`btn ${className ?? ''} ${color ? ButtonColors[color] : ''}`} onClick={onClick}>
        {title}
      </button>
      {description && <span>{description}</span>}
    </div>
  );
};

export default memo(Button);
